import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { catchError, debounceTime, finalize, last, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { FileService } from 'src/app/shared/services/rest/file.service';
import { SnackBarItem } from '../../../snack-bar/snack-bar-item';
import { forkJoin, from, of, ReplaySubject } from 'rxjs';
import { ParametersService } from 'src/app/shared/services/rest/parameters.service';
import { mimeTypes } from 'mime-wrapper';
import { LoadingService } from 'src/app/shared/services/rest/loading.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SelectFileComponent } from '../select-file/select-file.component';

@Component({
  selector: 'app-ve-transpose',
  templateUrl: './ve-transpose.component.html',
  styleUrls: ['./ve-transpose.component.scss']
})
export class VeTransposeComponent extends BaseClass implements OnInit, OnDestroy {
  public form: FormGroup;

  public isLoop: boolean = true;
  public isRandomAudio: boolean = false;
  public isReverse: boolean = true;
  public isOpenAddSet: boolean = false;
  public isKeepAudio: boolean = true;
  public is_remember: boolean = !!this.sm.localStorageGetItem('rememberExportAudioTags') ? true : false;
  public parameters: any;
  public paramControl: FormControl = new FormControl();
  public parameters$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public direction: FormControl = new FormControl('clock');

  public rotateOptions:any = {
    'clock': 'Rotate clockwise',
    'cclock': 'Rotate counter-clockwise',
    'clock_flip': 'Rotate clockwise with vertical flip',
    'cclock_flip': 'Rotate counter-clockwise with vertical flip',
  }

  public tags: any[] = [];
  public videos: any[] = [];

  compareTags = (a: any, b: any) => a?.parameter_value_id === b?.parameter_value_id;

  public allValues: any;
  public allValuesControl: FormControl = new FormControl();
  public allValues$: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private ls: LoadingService,
    private sm: StorageManagerService,
    private dialog: MatDialog,
    private fileService: FileService,
    private parametersService: ParametersService,
    public dialogRef: MatDialogRef<VeTransposeComponent>,
    public layoutService: LayoutService
  ) { super() }

  ngOnInit(): void {
    console.log("VeTransposeComponent", this.data)
    this.videos = this.data.addVideos;

    if (!this.data.addVideos.length) {
      this.videos.push(this.data.file)
    }

    this.videos.forEach(video => {
      video.direction = this.direction.value;
    })
    this.form = this.fb.group({
      parameter_id: []
    })

    this.attachSubscriptions(
      this.direction.valueChanges.subscribe((resp) => {
        this.videos.forEach(video => {
          video.direction = resp;
        })
      })
    )

    this.attachSubscriptions(
      this.allValuesControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchValues(resp))
    )
    if (!!this.sm.localStorageGetItem('rememberExportAudioTags')) {
      let rememberExportAudioTags = JSON.parse(this.sm.localStorageGetItem('rememberExportAudioTags'));
      if (this.data.company.id && rememberExportAudioTags.company_id == this.data.company.id) {
        this.form.patchValue({
          parameter_id: rememberExportAudioTags.parameter_id
        })
      }
    }

    this.attachSubscriptions(
      this.paramControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchParams(resp))
    )
    
    this.getAllApiParameterValues();
    this.getParameters();
  }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
    // Если Angular вдруг не обновляет выбор — можно форсануть
    this.tags = [...this.tags];
  }

  onSearchValues(resp) {
    if (!this.allValues) {
      return;
    }

    if (!resp) {
      this.allValues$.next(this.allValues.slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }
    // filter the banks
    this.allValues$.next(
      this.allValues.filter(z => z.value.toLowerCase().indexOf(resp) > -1 || (z.parameter.name && z.parameter.name.toLowerCase().indexOf(resp) > -1))
    );
  }

  getValuesById(id) {
    return this.allValues && this.allValues.find(x => x.id == id)
  }

  getAllApiParameterValues() {
    this.attachSubscriptions(
      this.parametersService.getAllValues('1', this.data.company.id, null, '1').pipe(
        switchMap(el => {
          let pages = Math.ceil(el.headers.get('x-pagination-total-count') / 200)
          let arr = []
          for (let index = 1; index <= pages; index++) {
            arr.push(index)
          }

          return forkJoin(arr.map(x => this.parametersService.getAllValues(x, this.data.company.id).pipe(map(u => u.body)))).pipe(
            last(),
          )
        }),
      ).subscribe(res => {
        this.allValues = [].concat(...res)
        this.allValues$.next(this.allValues.slice())
      })
    )
  }
  

  selectFile(only, toVidLine:boolean = true) {
    let x:any = {
      company: this.data.company,
      task: this.data.task,
      work: this.data.work,
      user: this.data.user,
      only: only,
      is_multi: true,
      fromVE: true,
      selectedFiles: []
    }

    const dialogRef = this.dialog.open(SelectFileComponent, {
      data: x
    });

    this.attachSubscriptions(
      dialogRef.afterClosed().subscribe(result => {
        console.log("result", result)
        if (!!result && result.event == 'select' && result.data && result.data.length) {
          // ADDING AUDIOS
          if (only == 'video') {
            result.data.direction = this.direction.value;
            this.videos.push(...result.data)
          }
        }
      })
    )
  }

  deleteFile(item, arr , i) {
    arr.splice(i, 1)
  }
  
  getParamById(id) {
    return this.parameters && this.parameters.find(x => x.id == id)
  }

  getParameters() {
    this.attachSubscriptions(
      this.parametersService.getApiParameters(this.data.company.id).pipe(
        tap(res => {
          res.unshift({
            company_id: this.data.company.id,
            created_at: 0,
            id: 0,
            is_new_value: 0,
            name: "All tag categories",
            original_id: 0,
          })
          this.parameters = res;
          this.parameters$.next(this.parameters.filter(x => !!x.id).slice())
        }),
      ).subscribe(resp => {
        console.log("this.parameters", this.parameters)
      })
    )
  }

  onSearchParams(resp) {
    if (!this.parameters) {
      return;
    }

    if (!resp) {
      this.parameters$.next(this.parameters.filter(z => !!z.id).slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }
    // filter the banks
    this.parameters$.next(
      this.parameters.filter(z => !!z.id && (z.name.toLowerCase().indexOf(resp) > -1))
    );
  }

  close() {
    this.dialogRef.close({event: "close", data: false});
  }

  understandFileType(val) {
    if (!val) {
      return ""
    }
    
    if (val == 'application/pdf') {
      return 'pdf'
    } else if (val.indexOf("/") != -1) {
      return val.split('/')[0]
    } else {
      return ""
    }
  }

  multiSubmitForm() {
    this.rememberSelection();

    this.data.file.isRotating = true;
    let exportedArr = [];
    
    this.videos.filter(file => !!file.meta_height && !!file.meta_width).forEach(file => {
      let executeData:any = {
        inputs: {},
        filtergraphs: {},
      }


      if (file && file.hasOwnProperty('meta_has_audio') && file.meta_has_audio == 0) {
        file.is_detached = true;
      } else {
        file.is_detached = false;
      }
      if (!(Object.values(executeData.inputs) as any).filter(x => x.original_file_id == file.original_file_id).length) {
        executeData.inputs[`file_${file.original_file_id}`] = {
          original_file_id: file.original_file_id
        }
      }

      let options = [
        {
          "-map": `[resultV]`
        }
      ];

      if (!file.is_detached) {
        options.push({
          "-map": `[resultA]`
        })
      }

      
      let finalFG:any = {
        [`result`]: {
          "options": options,
          "is_consist": 1,
          "output_location": file.location,
          "output_filename": `Rotate Video - ` + file.filename,
        },
      }



      let cons = [`file_${file.original_file_id}`]

      executeData.filtergraphs[`fg0`] = {
        inputs: {
          "[0]": {
            "options": [],
            "input": `file_${file.original_file_id}`
          }
        },
        filtergraph: `
${!file.is_detached ? `[0:a]asetpts=PTS-STARTPTS,aformat=channel_layouts=stereo[resultA];` : ``}

[0:v]setpts=PTS-STARTPTS,transpose=dir=${file.direction}[resultV]`,
        outputs: finalFG
      } 

      finalFG[`result`].consists_of_files_keys = cons.join(',')
      
      let tagsData = [];
      if (this.form.get('parameter_id').value && this.form.get('parameter_id').value.length) {
        if (file.parameterValuesToTask) {
          file.parameterValuesToTask.forEach(tag => {
            let pvi = !!tag.parameter_value_id ? tag.parameter_value_id : tag.id;
            if (this.form.get('parameter_id').value.includes(tag.parameter_id) && tagsData.filter(q => q.parameter_value_id == pvi).length == 0) {
              tagsData.push({
                parameter_value_id: pvi,
                is_primary: tag.is_primary
              })
            }
          });
        }
      }

      if (this.tags.length) {
        this.tags.forEach(tag => {
          if (!tagsData.filter(k => k.parameter_value_id == tag.parameter_value_id).length) {
            tagsData.push(tag); 
          }
        })
      }
      if (tagsData.length) {
        finalFG[`result`].parameter_values = tagsData
      }

      exportedArr.push({
        editor_version: 'RV',
        company_id: file.company_id,
        task_id: file.task_id,
        task_operation_id: file.task_operation_id,
        discussion_id: file.discussion_id,
        name: `Rotate video ${this.rotateOptions[file.direction]} ${file.filename}`,
        output_location: file.location,
        is_draft: 1,
        // is_draft: 0,
        // is_to_process: 1,
        output_width: file ? (!!this.isReverse ? file.meta_height : file.meta_width) : 0,
        output_height: file ? (!!this.isReverse ? file.meta_width : file.meta_height) : 0,
        output_frame_rate: 25,
        output_audio_bit_rate: 192000,
        output_bit_rate: 0,
        waiting_time_limit: 86400,
        execute_data: executeData
      })
    });

    let count = 0;
    let lenSelection = exportedArr.length;

    if (!lenSelection) {
      this.layoutService.showSnackBar({name: 'There is no videos for rotating.'}, '', SnackBarItem)
      return
    }

    this.ls.requests$.next({
      value: 0,
      target: `Rotating ${lenSelection} video(s)`
    })

    from(exportedArr).pipe(
      mergeMap(x => this.fileService.createVideoProject(x, this.data.company_id).pipe(
        switchMap(project => {
          return this.fileService.editVideoProject(project.id, {
            is_draft: 0,
            is_to_process: 1,
          }, this.data.company_id).pipe(
            tap(k => {
              this.ls.requests$.next({
                value: Math.round((100 / lenSelection) * (count+1)),
                target: `Rotating ${lenSelection} video(s)`
              })
              count++;
              if (!!this.dialogRef) {
                this.close();
                this.data.file.isRotating = false;
              }
            }),
            map(editedProject => {
              return {
                project: project,
                editedProject: editedProject
              }
            })
          )
        }),
        catchError(() => of([])),
      ), 4), // 4 запроса параллельно
      finalize(() => {
        this.layoutService.showSnackBar({name: 'Rotating videos started'}, marker("successfully!"), SnackBarItem)
        // Этот блок выполнится только после обработки всех элементов
        console.log('Все запросы завершены');
        // Здесь можно дополнительно обработать card.is_ok_tags или другие поля
      }),
      last()
    ).subscribe(resp => {
    })
  }

  rememberSelection() {
    if (this.is_remember) {
      let rememberExportAudioTags = {
        company_id: this.data.company.id,
        parameter_id: this.form.value.parameter_id
      };
      this.sm.localStorageSetItem('rememberExportAudioTags', rememberExportAudioTags)
    }
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }
}
